import * as React from "react"
const Android = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#000"
        d="M1.172 10.809c.09-1.07.418-2.056.983-2.956a6.244 6.244 0 0 1 2.258-2.146l-1.11-1.92a.324.324 0 0 1-.045-.286c.03-.1.095-.175.195-.225.08-.05.17-.06.27-.03s.18.09.24.18l1.11 1.92c.861-.36 1.761-.54 2.702-.54.94 0 1.84.18 2.7.54l1.111-1.92a.43.43 0 0 1 .24-.18c.1-.03.19-.02.27.03.1.05.165.125.195.225s.015.195-.045.285l-1.11 1.92a6.237 6.237 0 0 1 2.258 2.147c.565.9.893 1.885.983 2.956H1.172Zm3.602-1.65c.21 0 .387-.073.533-.219a.722.722 0 0 0 .217-.532.725.725 0 0 0-.218-.533.722.722 0 0 0-.532-.217.725.725 0 0 0-.533.218.722.722 0 0 0-.218.532c0 .21.073.388.218.533a.722.722 0 0 0 .533.217Zm6.002 0c.21 0 .388-.073.533-.219a.722.722 0 0 0 .217-.532.725.725 0 0 0-.218-.533.722.722 0 0 0-.532-.217.725.725 0 0 0-.533.218.722.722 0 0 0-.218.532c0 .21.073.388.218.533a.722.722 0 0 0 .533.217Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.572.005h14.405V14.41H.572z" />
      </clipPath>
    </defs>
  </svg>
)
export default Android